export const IOW_DASHBOARD = {
	namespaced: true,
	state: {
		// Keep alive
		viewerOpened: false,
		selectedRowsData: [],
		coloredInspections: []
	},
	getters: {
		GET_VIEWER_OPENED(state) {
			return state.viewerOpened;
		},
		GET_SELECTED_ROWS_DATA(state) {
			return state.selectedRowsData;
		},
		GET_COLORED_INSPECTIONS(state) {
			return state.coloredInspections;
		}
	},
	mutations: {
		SET_VIEWER_OPENED(state, value) {
			state.viewerOpened = value;
		},
		SET_SELECTED_ROWS_DATA(state, value) {
			state.selectedRowsData = value;
		},
		SET_COLORED_INSPECTIONS(state, value) {
			state.coloredInspections = value;
		}
	},
	actions: {
		RESET({ commit }) {
			commit('SET_VIEWER_OPENED', false);
			commit('SET_SELECTED_ROWS_DATA', []);
			commit('SET_COLORED_INSPECTIONS', []);
		}
	}
}